const getters = {
  regionList: state => state.region.regionList,
  developer: state => state.developer.developer
}

export default getters